import { FaTrash } from "react-icons/fa";
import "./ScrollableListItem.css";
import { useState } from "react";
import RemoveListModal from "../RemoveListModal/RemoveListModal";

const ScrollableListItem = ({data, removeFunction, refresh, removeTitle,customButtons, removeText}) => {
    const [showRemoveModal, setShowRemoveModal] = useState(false);

    if(!customButtons)
        customButtons = []

    const removeClicked = (id) => {
        removeFunction(id);
        setShowRemoveModal(false);
    };

    let columnsArray = data.columns;

    if(!Array.isArray(data.columns)){
        columnsArray = [data.columns];
    }

    const renderCustomButton = (button, data) => {
        if(button.render) {
            return button.render(data);
        }

        return (
            <div onClick={() => button.onClick(data)}>
                {button.icon}
            </div>
        )
    }

    return (
        <div className="scrollableListItem flex">  
            <div className="flex gap-2 w-[90%]">
                { data.img &&
                    <img className={data.img.className} src={data.img.src}/>
                }

                <div className="flex-1">
                    { columnsArray.map(item => 
                        item
                    )}
                </div>
            </div>

            <div className="flex gap-4">
                { customButtons.map(button => 
                    renderCustomButton(button, data)
                )}

                { removeFunction &&
                    <div onClick={() => setShowRemoveModal(true)} >
                        <FaTrash className="iconBtn" size={"22px"}/>
                    </div>
                }
            </div>
            
            { showRemoveModal &&
                <RemoveListModal removeText={removeText} removeTitle={removeTitle} id={data.id} remove={removeClicked} hide={() => setShowRemoveModal(false)}/>
            }
        </div>
    );
}

export default ScrollableListItem;